import { render, staticRenderFns } from "./singleSelectList.vue?vue&type=template&id=229d14b4&scoped=true"
import script from "./singleSelectList.vue?vue&type=script&lang=js"
export * from "./singleSelectList.vue?vue&type=script&lang=js"
import style0 from "./singleSelectList.vue?vue&type=style&index=0&id=229d14b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229d14b4",
  null
  
)

export default component.exports